import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-portal',
  templateUrl: './footer-portal.component.html',
  styleUrls: ['./footer-portal.component.scss']
})
export class FooterPortalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
